import * as React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { IItem } from './types';

interface IProps {
    item: IItem;
    panelOutlineStyle: React.CSSProperties;
    panelBodyStyle: React.CSSProperties;
    pdfFieldLabelStyle: React.CSSProperties;
    file: File | null;
    onPick: (e: React.FormEvent<HTMLInputElement>) => void;
    embedded?: boolean;
}

const PhysicianLetterSection = ({
    item,
    panelOutlineStyle,
    panelBodyStyle,
    pdfFieldLabelStyle,
    file,
    onPick,
    embedded
}: IProps) => {
    const hasOnFile = item.hasActiveComplicationsReport === true;

    const inner = (
        <>
            <p className='text-muted' style={{ fontSize: 12, marginBottom: 12 }}>
                One complications report covers all selected complication weeks for this request. Upload is only required if no report is already on file.
            </p>
            {hasOnFile ? (
                <p style={{ marginBottom: 0, fontSize: 13 }}>
                    <Glyphicon glyph='ok-circle' style={{ color: '#5cb85c', marginRight: 6 }} />
                    A complications report is already on file for this request. No new upload is required.
                </p>
            ) : (
                <div className='form-group' style={{ marginBottom: embedded ? 0 : 14 }}>
                    <span className='control-label' style={pdfFieldLabelStyle}>Complications report (PDF)</span>
                    <div className='input-group input-group-sm'>
                        <span className='input-group-btn'>
                            <label className='btn btn-default' style={{ marginBottom: 0, cursor: 'pointer', borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>
                                <Glyphicon glyph='folder-open' style={{ marginRight: 5 }} />
                                Browse
                                <input type='file' accept='.pdf,application/pdf' style={{ display: 'none' }} onChange={onPick} />
                            </label>
                        </span>
                        <input
                            type='text'
                            className='form-control'
                            readOnly
                            value={file ? file.name : 'No file chosen'}
                            style={{
                                backgroundColor: '#fafbfc',
                                color: file ? '#333' : '#999',
                                cursor: 'default',
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );

    if (embedded) {
        return inner;
    }

    return (
        <div className='panel panel-default' style={{ ...panelOutlineStyle, marginTop: 0 }}>
            <div className='panel-body' style={panelBodyStyle}>
                {inner}
            </div>
        </div>
    );
};

export default PhysicianLetterSection;
